import styled from "styled-components";

const StyledSettings = styled.div`
    width: 100%;
    height: 100%;
`

export default StyledSettings;